import { useDispatch } from 'react-redux';
import EditDialog from '../Common/EditDialog';
import useClientGroupAddForm from '../../hooks/useClientGroupAddForm';
import { addClientGroup } from '../../redux/actions/clientGroups';

function AddClientGroup({ setAddClientGroup, id }) {
  const { addClientGroupFormSchema } = useClientGroupAddForm(id);

  const dispatch = useDispatch();

  const handleUpdate = (data: any) => {
    dispatch(addClientGroup(data.ClientId, id));
  };
  return (
    <EditDialog
      update={handleUpdate}
      onClose={() => setAddClientGroup(false)}
      formSchema={addClientGroupFormSchema}
    />
  );
}

export default AddClientGroup;
